import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../../config/config.service';
import { Produto } from '../../../../types/Produto.type';

@Injectable({
  providedIn: 'root'
})
export class ProdutoConfigService {

  private readonly basePath = '/pesagem-balanca/produto';

  constructor(private httpClient: HttpClient, private configService: ConfigService) {}

  findAll(instancia?: string): Observable<Produto[]> {
    const params: any = {};
    if (instancia) params['instancia'] = instancia;
    return this.httpClient.get<Produto[]>(`${this.configService.getApiUrlRoot()}${this.basePath}`, { params });
  }

  findById(id: string): Observable<Produto> {
    return this.httpClient.get<Produto>(`${this.configService.getApiUrlRoot()}${this.basePath}/${id}`);
  }

  create(produto: Produto): Observable<Produto> {
    return this.httpClient.post<Produto>(`${this.configService.getApiUrlRoot()}${this.basePath}`, produto);
  }

  update(id: string, produto: Produto): Observable<Produto> {
    return this.httpClient.put<Produto>(`${this.configService.getApiUrlRoot()}${this.basePath}/${id}`, produto);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.configService.getApiUrlRoot()}${this.basePath}/${id}`);
  }
}
